<template>
  <span class="">
    <el-form-item v-show="showAgentGroup" label="坐席组">
      <TreeSelect
        class="filter-tree"
        :multiple="false"
        :selectNotLeafNode="zxTreeSelectNotLeafNode"
        :data="storeUserGroupData"
        :defaultProps="grouptreeProp"
        :multipleChange="multipleChange"
        :singleChange="singleChange"
        :clearable="true"
        :treeDisable="zxTreeDisable"
        :selectPlaceholder="selectPlaceholder"
        ref="agentGroupTree"
        :size="size"
      ></TreeSelect>
    </el-form-item>
    <el-form-item v-show="showSkillGrouop" label="技能组">
      <el-select
        filterable
        multiple
        collapse-tags
        :size="size"
        :clearable="clearable"
        v-model="skillGroupValue"
        :disabled="sgDisabled"
        @change="changeSkillGroupOptions"
        placeholder="所有技能组"
        style="width:220px;"
      >
        <!-- <el-option filterable key="all" label="所有技能组" value="all"></el-option> -->
        <el-option
          v-for="item in storeSkillGroupData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-show="showAgent" label="坐席">
      <el-select
        :size="size"
        filterable
        multiple
        :clearable="clearable"
        collapse-tags
        v-model="agentValue"
        style="width:240px;"
        placeholder="所有坐席"
        @change="noticeChange()"
      >
        <el-option
          v-for="item in agentData"
          :key="item.id"
          :label="agentSelectLabel==='userName'?item.userName:item.realName"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
  </span>
</template>

<script>
import TreeSelect from '@/views/workreport/components/treeSelect/TreeSelect'
import { getAgentsByCondition, getUserGroupTree, getSkillGroupData } from '@/api/user'
import { recuUserGroupData } from '@/utils/authScopeFilterUtils'
export default {
  name: 'AgentStructure',
  components: {
    TreeSelect
  },
  data() {
    return {
      grouptreeProp: {
        children: 'children',
        label: 'name'
      },
      zxValue: [],
      skillGroupValue: [],
      agentValue: [],
      sgDisabled: false,
      zxTreeDisable: false,
      agentData: [],
      selectPlaceholder: '所有坐席组'
    }
  },
  watch: {
    zxValue(val) {
      this.changeSkillGroupDisabled()
    },
    skillGroupValue(val) {
      this.changeAgentGroupDisabled()
    }
  },
  props: {
    // 是否显示坐席组
    showAgentGroup: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 是否显示技能组
    showSkillGrouop: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 是否显示坐席
    showAgent: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 坐席显示框显示的label值:可选项userName/realName(默认显示realName)
    agentSelectLabel: {
      type: String,
      default() {
        return 'realName'
      }
    },
    // 是否需要坐席明细数据
    needAgentDetail: {
      type: Boolean,
      default() {
        return false
      }
    },
    // 下拉框size
    size: {
      type: String,
      default() {
        return 'small'
      }
    },
    // 坐席组是否允许选择叶子节点
    zxTreeSelectNotLeafNode: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 坐席组是否允许多选
    zxTreeMultiple: {
      type: Boolean,
      default() {
        return false
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return true
      }
    },
    // 分配的坐席组id
    ownAgentGroupIds: {
      type: Array,
      default() {
        return []
      }
    },
    // 分配的技能组id
    ownSkillGroupIds: {
      type: Array,
      default() {
        return []
      }
    },
    // 回调方法，传递AgentIds，格式为数组
    getAgentData: Function
  },
  computed: {
    storeUserGroupData() {
      if (this.$store.state.user.userGroupTree.length > 0 && this.ownAgentGroupIds.length > 0) {
        return this.filterAgentGroupData(this.ownAgentGroupIds)
      } else {
        return this.$store.state.user.userGroupTree
      }
    },
    storeSkillGroupData() {
      if (this.$store.state.user.skillGroupData.length > 0 && this.ownSkillGroupIds.length > 0) {
        return this.filterSkillGroupData(this.ownSkillGroupIds)
      } else {
        return this.$store.state.user.skillGroupData
      }
    }
  },
  mounted() {
    if (this.storeUserGroupData.length === 0) {
      this._getUserGroupTree({ type: 0 })
    }
    if (this.storeSkillGroupData.length === 0) {
      this._getSkillGroupData({ userGroupIds: [] })
    }
    this.loadAgentData()
  },
  methods: {
    changeAgentGroupDisabled() {
      if (this.skillGroupValue.length === 0) {
        this.zxTreeDisable = false
      } else {
        this.zxTreeDisable = true
      }
    },
    changeSkillGroupDisabled() {
      if (this.zxValue.length === 0) {
        this.sgDisabled = false
      } else {
        this.sgDisabled = true
      }
    },
    multipleChange(data) {
      this.zxValue = data
      this.changeZxTree()
    },
    singleChange(data) {
      this.zxValue = [data]
      this.changeZxTree()
    },
    changeSkillGroupOptions(ops) {
      if (ops.length > 0) {
        this.zxValue = []
        // const lastItem = ops[ops.length - 1]
        /* if (lastItem === 'all') { // 当前选中的是所有，则清除其他的选项
          this.skillGroupValue = ['all']
        } else if (this.skillGroupValue.indexOf('all') > -1) { // 包含‘all’时 移除‘all’
          this.skillGroupValue.splice(this.skillGroupValue.indexOf('all'), 1)
        } */
      }
      this.loadAgentData()
    },
    changeZxTree() {
      if (this.zxValue.length === 1 && this.zxValue[0] === '') {
        this.zxValue = []
      } else {
        this.skillGroupValue = []
      }
      this.loadAgentData()
    },
    loadAgentData() {
      this.agentValue = []
      const params = { sgIds: this.skillGroupValue, xzIds: this.zxValue }
      if (this.ownSkillGroupIds.length > 0 && this.skillGroupValue.length === 0) {
        params.sgIds = this.ownSkillGroupIds
      }
      if (this.ownAgentGroupIds.length > 0 && this.zxValue.length === 0) {
        params.xzIds = this.ownAgentGroupIds
      }
      getAgentsByCondition(params)
        .then((res) => {
          if (res.code === 2000) {
            if (res.data !== this.agentData) {
              this.agentData = res.data
              this.callBackAgentData(this.genCallBackValue())
            }
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {})
    },
    noticeChange() {
      this.callBackAgentData(this.genCallBackValue())
    },
    genCallBackValue() {
      const res = {}
      if (this.showAgentGroup) {
        res.agentGroupIds = this.zxValue
      }
      if (this.showSkillGrouop) {
        res.skillGroupIds = this.skillGroupValue
      }
      if (this.showAgent) {
        if (this.needAgentDetail) {
          if (this.agentValue.length > 0) {
            res.agentIds = this.agentValue
          } else {
            if (this.zxValue.length === 0 && this.skillGroupValue.length === 0) {
              res.agentIds = ['all']
            } else {
              res.agentIds = this.agentData.map(a => a.id)
            }
          }
        } else {
          res.agentIds = this.agentValue
        }
      }
      return res
    },
    callBackAgentData(data) {
      this.getAgentData(data)
    },
    /**
     * 清除所有选项
     */
    clearSelected() {
      this.$refs.agentGroupTree.clearSelected() // 清除坐席组
      this.skillGroupValue = [] // 清除技能组
      this.sgDisabled = false
      // 清除坐席
      this.loadAgentData()
    },
    /**
     * 获取userGroup数据
     * type = 0  只获取组织树，不带坐席人员
     * type = 1  获取组织树+坐席人员
     */
    _getUserGroupTree({ type }) {
      getUserGroupTree(type, false)
        .then((res) => {
          if (res.code === 2000) {
            if (type === '1') {
              this.$store.commit('user/setUserGroupData', { data: res.data })
            } else {
              this.$store.commit('user/setUserGroupTree', { data: res.data })
            }
          }
        })
        .catch(() => {})
    },
    /**
     * 获取skillgroup数据
     */
    _getSkillGroupData({ userGroupIds }) {
      getSkillGroupData({ userGroupIds })
        .then((res) => {
          if (res.code === 2000) {
            this.$store.commit('user/setSkillGroupData', { data: res.data })
          }
        })
        .catch(() => {})
    },
    setDefaultValue(_skillGroupIds, _userGroupIds, _agentIds) {
      if (_skillGroupIds && _skillGroupIds.length > 0) {
        this.skillGroupValue = []
        this.skillGroupValue.push(..._skillGroupIds)
      }
      if (_agentIds && _agentIds.length > 0) {
        this.agentValue = []
        this.agentValue.push(..._agentIds)
      }
      if (_userGroupIds && _userGroupIds.length > 0) {
        this.zxValue = []
        this.zxValue.push(..._userGroupIds)
        this.$refs.agentGroupTree.setDefaultValue(_userGroupIds)
      }
    },
    filterAgentGroupData(_ownAgentGroupIds) {
      const _userGroupTree = this.$store.state.user.userGroupTree
      const _ownAgentGroup = [recuUserGroupData(_userGroupTree, _ownAgentGroupIds[0])]
      return _ownAgentGroup
    },
    filterSkillGroupData(_ownSkillGroupIds) {
      const _skillGroupData = this.$store.state.user.skillGroupData
      const _ownSkillGroup = _skillGroupData.filter(item => _ownSkillGroupIds.indexOf(item.id) !== -1)
      return _ownSkillGroup
    }
  }
}
</script>
